import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { GetItemsRequest, GetItemsResponse } from '../types';

export class GzSingleSelectComplexBaseDataProvider extends BaseWebComponentDataProvider {
  // This is the default state, it should only be changed for specific filters,
  // mainly for the ones that don't work for MDR users with more than 1000 targets
  shouldWorkWithoutTotalCount = false;

  async getItems(request: GetItemsRequest): Promise<GetItemsResponse | undefined> {
    throw new Error('Needs to be implemented');
  }

  async getInitialItems(request: GetItemsRequest): Promise<GetItemsResponse | undefined> {
    throw new Error('Needs to be implemented');
  }
}
